var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    stroke: "none",
    strokeWidth: 1.5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5H13.75C14.1642 5 14.5 4.66421 14.5 4.25V1.75C14.5 1.33579 14.1642 1 13.75 1H6.25C5.83579 1 5.5 1.33579 5.5 1.75V4.25C5.5 4.66421 5.83579 5 6.25 5H7M13 5V9.84015C13 10.2606 13.1765 10.6618 13.4864 10.9459L18.5136 15.5541C18.8235 15.8382 19 16.2394 19 16.6599V19.5C19 20.3284 18.3284 21 17.5 21H2.5C1.67157 21 1 20.3284 1 19.5V16.6599C1 16.2394 1.17647 15.8382 1.48641 15.5541L6.51359 10.9459C6.82353 10.6618 7 10.2606 7 9.84015V5M13 5H10H7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestCases);
export default __webpack_public_path__ + "static/media/test-cases.bb22076b65490bd33faf2585ba1fb0db.svg";
export { ForwardRef as ReactComponent };